<div class="edit-project">
  <div class="underline upper-space" #companySection>
    <div class="container">
      <div
        [class.collapsed]="isCollapsedCompany"
        class="fixed-section-header-height d-flex clickable"
        (click)="expandCompany()"
        [attr.aria-expanded]="!isCollapsedCompany"
      >
        <h2 class="flexer">
          Bedrijf
        </h2>
        <button class="edit-button btn btn-sm pull-right" mat-icon-button>
          <mat-icon svgIcon="edit"></mat-icon>
        </button>
        <button mat-icon-button class="arrow-button pull-right">
          <mat-icon svgIcon="arrow-up"></mat-icon>
        </button>
      </div>

      <div
        id="collapseCompany"
        [collapse]="isCollapsedCompany"
        [isAnimated]="!safari"
        (expanded)="scrollTo(companySection)"
      >
        <contact-picker
          [inputProject]="project"
          [fromOldSystem]="true"
          (projectContactChange)="setContacts($event)"
          (next)="contactNext()"
        ></contact-picker>
      </div>
    </div>
  </div>

  <div class="underline upper-space" *ngIf="!isHiddenProject" #projectSection>
    <div class="container">
      <div
        [class.collapsed]="isCollapsedProject"
        class="section-header d-flex clickable"
        (click)="expandProject()"
        [attr.aria-expanded]="!isCollapsedProject"
      >
        <h2 class="flexer fixed-section-header-height">
          Project
        </h2>
        <button class="edit-button btn btn-sm pull-right" mat-icon-button>
          <mat-icon svgIcon="edit"></mat-icon>
        </button>
        <button mat-icon-button class="arrow-button">
          <mat-icon svgIcon="arrow-up"></mat-icon>
        </button>
      </div>

      <div
        id="collapseProject fullLength"
        [collapse]="isCollapsedProject"
        [isAnimated]="!safari"
        (expanded)="scrollTo(projectSection)"
      >
        <div class="">
          <product-picker
            *ngFor="let product of this.project.products; let index = index"
            [inputProject]="project"
            [inputProduct]="product"
            [index]="index"
            [fromOldSystem]="true"
            (typeWasSelected)="productTypeWasSelected()"
          >
          </product-picker>

          <mat-card
            *ngIf="showAddProduct"
            class="mat-elevation-z0 clickable overflow-hidden vertically-center"
            (click)="addProduct()"
          >
            <mat-icon
              class="plus-sign vertically-center"
              svgIcon="add"
            ></mat-icon>
            <span class="vertically-center">Onderdeel toevoegen</span>
          </mat-card>
        </div>

        <div class="flexer text-right">
          <button
            class="button"
            (click)="projectNext($event)"
            type="button"
            mat-button
          >
            Volgende
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="underline upper-space" *ngIf="!isHiddenProject" #placementSection>
    <div class="container">
      <div
        [class.collapsed]="isCollapsedPlacement"
        class="section-header d-flex clickable"
        (click)="expandPlacement()"
        [attr.aria-expanded]="!isCollapsedPlacement"
      >
        <h2 class="flexer">
          Plaatsing
        </h2>
        <button class="edit-button btn btn-sm pull-right" mat-icon-button>
          <mat-icon svgIcon="edit"></mat-icon>
        </button>
        <button mat-icon-button class="arrow-button">
          <mat-icon svgIcon="arrow-up"></mat-icon>
        </button>
      </div>

      <div
        id="collapsePlacement"
        [collapse]="isCollapsedPlacement"
        [isAnimated]="!safari"
        (expanded)="scrollTo(placementSection)"
      >
        <div class="upper-space">
          <placement-picker
            [inputProject]="project"
            [inputSubProject]="baseProject"
            [inputProjectPlacement]="baseProject.projectPlacement"
            [fromOldSystem]="true"
          >
          </placement-picker>
        </div>

        <div class="flexer text-right">
          <button
            class="button"
            type="button"
            mat-button
            [disabled]="submitDisabled"
            (click)="submit()"
          >
            Indienen
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
